import React from "react";
import "./index.scss";
import TabPanel from "devextreme-react/tab-panel";
import { IMdaeTabPanelProps } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";

const MdaeTabPanel: React.FC<IMdaeTabPanelProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div>
      <TabPanel
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_TAB_PANEL,
            e.component,
            dispatch
          );
        }}
      />
    </div>
  );
};
export default MdaeTabPanel;
